
import { on } from 'delegated-events';
import helpers from './helpers';

export default (function () {
  return {
    init() {
      const paralaxEls = document.querySelectorAll('.js-prlx');
      if (paralaxEls.length === 0) return;

      [...paralaxEls].forEach((paralaxEl) => {
        let lastScrollY = 0;
        let ticking = false;
        const parent = paralaxEl.parentElement;
        const offsetMax = parseInt(paralaxEl.getAttribute('data-paralax-max'), 10) || 100;
        const inverse = paralaxEl.getAttribute('data-paralax-inverse') === 'true';
        const initialOffset = parseInt(paralaxEl.getAttribute('data-paralax-initial-offset'), 10) || 0;

        /**
        * Our animation callback
        */
        function update() {
          const rect = parent.getBoundingClientRect();
          const wH = document.documentElement.clientHeight;
          const factor = helpers.breakpoint(parent) === 'tablet' ? 2 : 1;

          const offset = {
            top: rect.top,
          };

          const { top } = offset;
          const pos = (wH - top) / (parent.offsetHeight + wH);

          if (pos > 1 || pos < 0) {
            ticking = false;
            return;
          }

          let val = (offsetMax / factor) * pos;

          if (inverse) {
            val = -Math.abs(val);
          }

          val += (initialOffset / factor);

          paralaxEl.style.transform = `translateY(${val}px)`;

          ticking = false;
        }

        /**
        * Calls rAF if it's not already
        * been done already
        */
        function requestTick() {
          if (!ticking) {
            requestAnimationFrame(update);
            ticking = true;
          }
        }

        /**
        * Callback for our scroll event - just
        * keeps track of the last scroll value
        */
        function onScroll() {
          if (helpers.breakpoint(parent) === 'mobile') return;
          lastScrollY = window.pageYOffset;
          requestTick();
        }


        window.addEventListener('scroll', onScroll, false);
        window.addEventListener('resize', onScroll, false);
      });
    },
  };
}());
